import React from 'react';

import { Typography, type TypographyProps, Tooltip } from '@mui/material';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export type FaColoredIconProps = {
    iconProps?: Omit<FontAwesomeIconProps, 'icon'>;
    icon: FontAwesomeIconProps['icon'];
    color?: TypographyProps['color'];
    tooltip?: string;
};

export const FaColoredIcon: React.FunctionComponent<FaColoredIconProps> = function ({
    ...props
}: FaColoredIconProps) {
    return props.tooltip ? (
        <Tooltip title={props.tooltip}>
            <Typography
                data-testid="FaColoredIcon-Typography"
                display="inline"
                color={props.color}
            >
                <FontAwesomeIcon
                    data-testid="FaColoredIcon-FontAwesomeIcon"
                    icon={props.icon}
                    {...props.iconProps}
                />
            </Typography>
        </Tooltip>
    ) : (
        <Typography
            data-testid="FaColoredIcon-Typography"
            display="inline"
            color={props.color}
        >
            <FontAwesomeIcon
                data-testid="FaColoredIcon-FontAwesomeIcon"
                icon={props.icon}
                {...props.iconProps}
            />
        </Typography>
    );
};
